import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from "../../common/component/notification/notification.service";
import { DxDataGridComponent, DxDropDownBoxComponent, DxListComponent, DxSelectBoxComponent, DxTextBoxComponent } from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
import { forkJoin } from 'rxjs';
import { DistanceToPlantService } from "./distanceToPlantService";
import { GetDistanceToPlantDataInputs, CountryData, ZipDeatils } from "./types/DistanceToPlantReport";
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-distance-to-plant',
  templateUrl: './distance-to-plant.component.html',
  styleUrls: ['./distance-to-plant.component.scss']
})
export class DistanceToPlantComponent implements OnInit {

  @ViewChild("zipTextBox", { static: false }) dxZipCode: DxTextBoxComponent;

  isLoadPanelVisible: boolean = true;
  disableReportBtn: boolean = true;
  selectedCountry: string;
  CountryDataSource: DataSource<any, any>;
  miles: number;
  zip: string;
  reportParams: GetDistanceToPlantDataInputs;
  integerOnlyPattern = '^[0-9]*$';
  dataSource: any;
  zipDetails: ZipDeatils;
  showReport: boolean = false;
  readonly allowedPageSizes = [10, 20, 50, 100, 200];
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  constructor(private notificationService: NotificationService,
    private distnceSvc: DistanceToPlantService) { }

  ngOnInit(): void {
    this.selectedCountry = "US";
    this.miles = 200;
    this.getAllCountries();
  }

  getAllCountries() {
    this.distnceSvc.getAllCountries().subscribe({
      next: data => {
        this.isLoadPanelVisible = false;
        this.CountryDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'countryId',
          },
        });
      }
    })
  }

  validationCallbackUS(params) {
    return params.value.length == 5;
  }

  validationCallbackCA(params) {
    return params.value.length >= 3 && params.value.length <= 7;
  }

  getReports() {
    if(!this.dxZipCode.isValid) return;

    this.isLoadPanelVisible = true;
    this.reportParams = new GetDistanceToPlantDataInputs(this.zip, this.miles, this.selectedCountry);
    var reportdata = this.distnceSvc.getReportData(this.reportParams);
    var zipDeatils = this.distnceSvc.getZipDetails(this.zip, this.selectedCountry);
    forkJoin([reportdata, zipDeatils]).subscribe(([reportdata, zipDeatils]) => {
      this.dataSource = reportdata;
      this.zipDetails = zipDeatils;
      this.showReport = true;
      this.isLoadPanelVisible = false;
    });
  }

  resetFilters() {
    this.dataGrid.instance.clearFilter();
  }

  exportExcel(e) {
    this.isLoadPanelVisible = true;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DistanceToPlant.xlsx');
        });
    }).then(() => {
      this.isLoadPanelVisible = false;
    });

    e.cancel = true;
  }

}
